var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBluecheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/action/checked/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10334029,7.96762325 C2.96555324,7.8263429 2.96555324,7.59087564 3.10334029,7.44959529 L3.6085595,6.93156733 C3.74634656,6.79028698 3.97599165,6.79028698 4.11377871,6.93156733 L6.96137787,9.87490802 C7.05323591,9.96909492 7.21398747,9.96909492 7.30584551,9.87490802 L12.8862213,4.10596026 C13.0240084,3.96467991 13.2536534,3.96467991 13.3914405,4.10596026 L13.8966597,4.62398823 C14.0344468,4.76526858 14.0344468,5.00073584 13.8966597,5.14201619 L7.39770355,11.8763797 C7.25991649,12.0412068 7.0302714,12.0412068 6.89248434,11.8763797 L3.10334029,7.96762325 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/action/checked/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "box",
    fill: "#005082",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "color",
    mask: "url(#mask-4)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBluecheckboxChecked);
export default __webpack_public_path__ + "static/media/icon_bluecheckbox_checked.7294a711450f9f6b6e814d2ca8f077c5.svg";
export { ForwardRef as ReactComponent };